import { Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

// Define the shape of an alert object with button support
interface AlertButton {
    text: string;
    onClick: () => void;
    className?: string;
}

// Define the shape of an alert object
interface Alert {
    id?: string;
    type?: string;
    message?: string;
    msgtimeout?: number;
    isShowSwal?: boolean;
    showButton?: boolean;
    button?: AlertButton;
    autoClose?: boolean;
}

// Typed Subject for alerts
const alertSubject = new Subject<Alert>();
const defaultId = 'default';
const timeout = 3000; // Default timeout for alerts

const autoClose = true; 
const keepAfterRouteChange = false;
const msgOptions = { autoClose, keepAfterRouteChange };

//rxjs alert service for show alerts across applications
export const alertService = {
    onAlert,
    success,
    error,
    info,
    warn,
    alert,
    clear,
};
//alert types
export const alertType = {
    success: 'success',
    error: 'error',
    info: 'info',
    warning: 'warning'
}

// Listen for alerts with a specific ID
function onAlert(id = defaultId) {
    return alertSubject.asObservable().pipe(
        filter((x: Alert) => x && x.id === id)
    );
}

function success(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false , showButton: boolean = false, button?: AlertButton) {
    alert({ ...msgOptions, type: alertType.success, message, msgtimeout, isShowSwal, showButton , button });
}

function error(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false , showButton: boolean = false, button?: AlertButton) {
    alert({ ...msgOptions, type: alertType.error, message, msgtimeout, isShowSwal, showButton, button });
}

function info(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false , showButton: boolean = false, button?: AlertButton) {
    alert({ ...msgOptions, type: alertType.info, message, msgtimeout, isShowSwal, showButton, button });
}

function warn(message: string, msgtimeout: number = timeout, isShowSwal: boolean = false , showButton: boolean = false, button?: AlertButton) {
    alert({ ...msgOptions, type: alertType.warning, message, msgtimeout, isShowSwal, showButton, button });
}

// function alert(alert: { id?: string, type?: string, message?: string, msgtimeout?: number, isShowSwal?: boolean }) {
//     alert.id = alert.id || defaultId;
//     alertSubject.next(alert);
// }

function alert(alert: Alert) {
    alert.id = alert.id || defaultId;

    // If msgtimeout is 0, treat as "infinite" → disable autoClose
    if (alert.msgtimeout === 0) {
        alert.autoClose = false;
    } else if (alert.autoClose === undefined) {
        alert.autoClose = true; // fallback to default
    }
    
    alertSubject.next(alert);
}

function clear(id = defaultId) {
    alertSubject.next({ id });
}